/**
 * OCHAT: manda los enlaces "Aprender más" a la guía propia en lugar de a la
 * documentación de Chatwoot.
 *
 * Las pantallas de configuración pasan `feature-name` a BaseSettingsHeader, que
 * resuelve el enlace con getHelpUrlForFeature(). Este módulo se consulta primero
 * desde ahí: si Ochat tiene un tema para esa feature, devuelve la ruta interna; si
 * no, upstream sigue resolviendo como siempre y el enlace va a su documentación.
 *
 * Eso deja el cambio en un solo lugar y hace que agregar un tema a ./topics.js
 * alcance para desviar el enlace de esa pantalla. Las secciones reservadas al
 * super admin no necesitan tema: su enlace no lo ve nadie más que el operador.
 *
 * El accountId sale del store y no del composable useAccount porque esto se llama
 * desde una función suelta, fuera del setup de un componente.
 */
import store from 'dashboard/store';
import { GUIDE_TOPICS } from './topics';

/**
 * @param {string} featureName el `feature-name` que declara la pantalla
 * @returns {string|undefined} la ruta de la guía, o undefined si no hay tema propio
 */
export const ochatHelpUrl = featureName => {
  if (!Object.hasOwn(GUIDE_TOPICS, featureName)) return undefined;

  const accountId = store.getters.getCurrentAccountId;
  if (!accountId) return undefined;

  return `/app/accounts/${accountId}/guide/${featureName}`;
};

export default ochatHelpUrl;
